import styles from '@styles/not-found.module.css'
import Link from "next/link";

export default function PageNotFound() {
  return (
    <main style={{ backgroundColor: "white"}}>
      <section className={styles.not_found}>
        <p>404</p>
        <p>Page not found</p>
        <Link href="/">Go Back Home</Link>
      </section>
    </main>
  );
}
